import React from 'react';
import { ProductTile } from '../../molecules/productTile/ProductTile';
import { graphql, useStaticQuery } from 'gatsby';
import './style.css';

export const ProductTiles = ({
	items,
}: {
	items?: Record<string, unknown>;
}) => {
	const { products, sep } = useStaticQuery(graphql`
		query ProductTiles {
			products: allDatoCmsProductTile(
				sort: { position: ASC }
				filter: {
					isVisible: { eq: true }
					id: { ne: "DatoCmsProductTile-48602652" }
				}
			) {
				nodes {
					title
					subtitle
					icon
					pagePath
					id
					image {
						gatsbyImageData(width: 80, placeholder: BLURRED)
					}
				}
			}
			sep: allDatoCmsProductTile(
				filter: { id: { eq: "DatoCmsProductTile-HQGKlNtaR6KlnPTVid6_wg" } }
			) {
				nodes {
					title
					icon
					pagePath
					subtitle
					image {
						gatsbyImageData
					}
					id
				}
			}
		}
	`);

	const supplierEarlyPayments = sep.nodes[0];

	const newProducts = [...products.nodes].filter(
		(p) => p.title !== 'Low-Doc Invoice Finance'
	);

	return (
		<div className={'grid gap-16 small-desktop:grid-cols-3'}>
			{(items || newProducts).map((product) => (
				<ProductTile
					tileClass={'w-full'}
					title={product.title}
					body={product.body || product.subtitle}
					image={product.image.gatsbyImageData}
					path={product.path || product.pagePath}
					icon={product.icon}
					key={product.id}
				/>
			))}
		</div>
	);
};
